import React from 'react';
import { Controller } from 'react-hook-form';
import Input, { Checkbox } from '../../../components/ui/Input';

export default function Step1({ control, errors, trigger, isCreation, showInDashboard, setShowInDashboard }) {
  const validate = async (field) => { await trigger(field); };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Controller name="title" control={control}
          rules={{ required: 'Title is required' }}
          render={({ field }) => (
            <Input label="Plan Title" {...field} disabled={!isCreation}
              onChange={e => { field.onChange(e); validate('title'); }}
              error={errors.title?.message} />
          )} />

        <Controller name="upload_once_content_capacity" control={control}
          rules={{ required: 'Required' }}
          render={({ field }) => (
            <Input label="Upload Once Capacity (MB)" type="number" {...field}
              onChange={e => { field.onChange(e.target.value ? Number(e.target.value) : ''); validate('upload_once_content_capacity'); }}
              error={errors.upload_once_content_capacity?.message} />
          )} />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Controller name="media_storage_capacity" control={control}
          rules={{ required: 'Required' }}
          render={({ field }) => (
            <Input label="Media Storage Capacity (MB)" type="number" {...field}
              onChange={e => { field.onChange(e.target.value ? Number(e.target.value) : ''); validate('media_storage_capacity'); }}
              error={errors.media_storage_capacity?.message} />
          )} />

        <Controller name="playlist_capacity" control={control}
          rules={{ required: 'Required' }}
          render={({ field }) => (
            <Input label="Playlist Capacity" type="number" {...field}
              onChange={e => { field.onChange(e.target.value ? Number(e.target.value) : ''); validate('playlist_capacity'); }}
              error={errors.playlist_capacity?.message} />
          )} />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Controller name="email_quota" control={control}
          rules={{ required: 'Required' }}
          render={({ field }) => (
            <Input label="Email Quota (per month)" type="number" {...field}
              onChange={e => { field.onChange(e.target.value ? Number(e.target.value) : ''); validate('email_quota'); }}
              error={errors.email_quota?.message} />
          )} />
      </div>

      <Controller name="orientation" control={control}
        render={({ field }) => (
          <div>
            <label className="label">Screen Orientation</label>
            <select className="input-base" {...field}>
              <option value="landscape">Landscape</option>
              <option value="portrait">Portrait</option>
              <option value="both">Both</option>
            </select>
          </div>
        )} />

      <Checkbox
        id="show_in_dashboard"
        label="Show this plan in the client dashboard"
        checked={Boolean(showInDashboard)}
        onChange={() => setShowInDashboard(prev => !prev)}
      />
    </div>
  );
}
